import React from 'react';

class FbLikeButton extends React.Component {
  componentDidMount() {
    if (!window.FB) {
      throw Error('FB SDK not loaded');
    }

    FB.XFBML.parse(this.root.parentNode);
  }

  render() {
    return (
      <div className="fb-like"
        ref={root => this.root = root}
        data-href="https://www.facebook.com/Stacjaborszcz"
        data-width="300"
        data-layout="standard"
        data-action="like"
        data-size="large"
        data-show-faces="true"
        data-share="true" />
    );
  }
}

export default FbLikeButton;



// WEBPACK FOOTER //
// ./src/components/common/Facebook/FbLikeButton.js